import { lifecycle } from 'recompose';
import { get } from 'lodash';

// Make sure to import getNearbyFacilities action into the searchPage
export default lifecycle({
	componentDidMount() {
		const { facilities, firstListingIsVipElegible, firstFacilityAccountId, actions, searchParams } = this.props;
		if (facilities.length && firstListingIsVipElegible && firstFacilityAccountId) {
			actions.getNearbyFacilities(searchParams.location, firstFacilityAccountId);
		}
	},
	componentDidUpdate(prevProps) {
		const { firstFacilityAccountId, actions, searchParams } = this.props;
		if (searchParams !== get(prevProps, 'searchParams')) {
			actions.getNearbyFacilities(searchParams.location, firstFacilityAccountId);
		}
	}
});
